export enum AssetListMode{
  allAssets = 1,
  noCheckedOut = 2,
  includeCheckedOut = 3,
  checkedOutOnly = 4,
  availableForCheckOut = 5,
  availableForCustodyTransfer = 6
}
